<template>
	<el-row style="overflow: hidden;">
		<el-row class="row-bg headList">
			<blockSpacList :list="headList"></blockSpacList>
		</el-row>
		<el-row class="row-bg contentList">
			<el-row class="title">
				<el-col :span="23" class="contentList-head"> 客户确认方案 </el-col>
				<el-col :span="1">
					<el-button type="primary" size="mini" @click="onlinePlanExcel">导出</el-button>
				</el-col>
			</el-row>
			<blockSpacList :list="contentList" labelWidth="200px"></blockSpacList>
		</el-row>
		<!-- 核心和关键词拓展列表 -->
		<el-col :span="24" class="google-list">
			<client-module class="clientmodule" moduletitle="核心和关键词拓展列表">
				<el-row slot="event" class="google-list-head">
					<el-button type="primary" size="mini" @click="extension">导出</el-button>
				</el-row>
				<data-list
					class="datalisat-css"
					:page="page"
					:table-style="{ name: 'webclient' }"
					:data="data"
					:columns="columns"
					:loading="loading"
					@page-size-changed="pageSizeChanged"
					@page-changed="pageChanged"
					@sort-change="sortChange"
				></data-list>
			</client-module>
		</el-col>
	</el-row>
</template>

<script>
import customer from '@/mixins/customer';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import blockSpacList from '@/backend/pages/googleAds/components/blockSpacList.vue';
import clientModule from '@/components/client/clientModule/clientModule.vue';
import { download2 } from '@/common/util.js';
import adsApi from '@/backend/services/googleAds/googleAds.js';
import productWordCard from '@/backend/pages/googleAds/components/productWordCard.vue';
//获取新用户上线方案列表的数据
const page = listPageCreate({
	searchConfig: {
		api: api.googleAds.onlinePlan,
		method: 'POST',
	},
	getQuery(data, that) {
		return _.assign(data, { serviceId: that.$route.query.serviceId });
	},
});
export default {
	components: {
		blockSpacList,
		clientModule,
	},
	mixins: [customer, page],
	data() {
		return {
			filterParams: null,
			keywordsList: [],
			headList: {},
			contentList: {},
			columns: [
				{
					label: '关键词',
					bind: 'keyword',
					align: 'left',
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '来源',
					bind: 'resourceType',
					align: 'left',
					width: 300,
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '竞争程度',
					bind: 'competition',
					align: 'left',
					type: 'percentage',
					dataStyle(val) {
						return val || '-';
					},
				},
				{
					label: '月搜索量',
					width: 250,
					bind: 'searchValue',
					align: 'left',
					type: 'percentage',
					dataStyle(val) {
						return val || '-';
					},
				},
			],
		};
	},
	provide() {
		//  0 全部线索  1 线索列表详情  2 公海线索  3 垃圾线索
		return {
			keywordsList: this.productWordCardData,
		};
	},
	methods: {
		requestData() {
			this.query();
			this.details();
		},
		async details() {
			let serviceSiteId = this.$route.query.serviceId;
			let res = await adsApi.details({ serviceSiteId: serviceSiteId });
			let {
				customerName,
				cid,
				serviceCode,
				excludedCountry,
				keywordsList,
				createTime,
				budget,
				creater,
			} = res.data;
			let excludedCountryToString = excludedCountry.join('、');
			this.keywordsList = keywordsList;
			(this.contentList = {
				row0: [{ label: '已排除国家/地区：', value: excludedCountryToString }],
				row1: [
					{
						label: '已选核心产品词：',
						type: productWordCard,
						keywordsList: keywordsList,
					},
				],
				row2: [{ label: '账户日预算：', value: budget }],
				row3: [{ label: '确认人：', value: creater }],
				row4: [{ label: '确认时间：', value: createTime }],
			}),
				(this.headList = {
					row0: [
						{ label: '客户名称：', value: customerName },
						{ label: '服务单号：', value: serviceCode },
						{ label: 'CID：', value: cid },
					],
				});
		},
		// 下载关键词数据
		async onlinePlanExcel() {
			let serviceSiteId = this.$route.query.serviceId;
			this.downloading = true;
			let res = await adsApi.onlinePlanExcel({ serviceSiteId: serviceSiteId });
			this.downloading = false;
			download2(res.data, `已选核心产品词列表.xlsx`);
			this.downloading = false;
		},
		async extension() {
			let serviceSiteId = this.$route.query.serviceId;
			this.downloading = true;
			let res = await adsApi.extension({ serviceSiteId });
			this.downloading = false;
			download2(res.data, `核心和关键词拓展列表.xlsx`);
			this.downloading = false;
		},
		productWordCardData() {
			return this.keywordsList;
		},
	},
	mounted() {
		this.requestData();
	},
};
</script>

<style scoped lang="scss">
.contentList-head {
  font-size: 16px;
  color: #333;
}

.headList {
  padding-top: 20px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  height: 64px;
  margin-left: -76px;
}

.contentList {
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-top: 20px;
  padding-left: 20px;

  .title {
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
}

.google-list {
  background-color: #fff;

  .google-list-head {
    // padding: 20px 15px 0px 15px;
    font-weight: 600;
    color: #333;
    display: flex;
    justify-content: space-between;
  }
}

::v-deep .blocK-list {
  padding: 10px 0 !important;
}
</style>
